/* Malibu & Billy - Street White theme JS
   Ported from the approved design preview. No dependencies. */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var f = T.moneyFormat || '${{amount}}';
    var v = (cents || 0) / 100, s;
    if (f.indexOf('amount_no_decimals_with_comma_separator') > -1) s = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (f.indexOf('amount_no_decimals') > -1) s = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else if (f.indexOf('amount_with_comma_separator') > -1) s = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else s = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function moneyShort(c) { return money(c).replace(/[.,]00(?=D*$)/, ''); }
  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- overlays ---------- */
  function open(id) {
    var el = document.getElementById(id); if (!el) return;
    el.classList.add('show');
    if (id === 'cart') { var sc = $('#scrim'); if (sc) sc.classList.add('show'); }
    if (id === 'mnav') { var ms = $('#mnavScrim'); if (ms) ms.classList.add('show'); }
    if (id === 'search') { var inp = el.querySelector('input[type=search]'); if (inp) setTimeout(function () { inp.focus(); }, 50); }
    if (id === 'cart') refreshCart();
  }
  function close(id) {
    var el = document.getElementById(id); if (el) el.classList.remove('show');
    if (id === 'cart') { var sc = $('#scrim'); if (sc) sc.classList.remove('show'); }
    if (id === 'mnav') { var ms = $('#mnavScrim'); if (ms) ms.classList.remove('show'); }
    if (id === 'popup') markPopupSeen();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]') || (function(a){ return a && /^#sg(Harness|Hoodie)$/.test(a.getAttribute('href')||'') ? { getAttribute: function(){ return a.getAttribute('href').slice(1); } } : null; })(e.target.closest('a[href^="#sg"]'));
    if (o) { e.preventDefault(); open(o.getAttribute('data-open')); return; }
    var c = e.target.closest('[data-close]');
    if (c) { if (c.tagName !== 'A') e.preventDefault(); close(c.getAttribute('data-close')); return; }
    if (e.target.classList && e.target.classList.contains('popup')) { e.target.classList.remove('show'); if (e.target.id === 'popup') markPopupSeen(); }
    var sc = e.target.closest('[data-scrollto]');
    if (sc) { var tgt = document.getElementById(sc.getAttribute('data-scrollto')); if (tgt) { e.preventDefault(); tgt.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
  });
  var scrim = $('#scrim');
  if (scrim) scrim.addEventListener('click', function () { close('cart'); close('mnav'); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close('cart'); close('mnav'); $$('.popup.show').forEach(function (p) { p.classList.remove('show'); if (p.id === 'popup') markPopupSeen(); }); }
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !e.target.closest('input,textarea,select')) {
      var gm = $('[data-gallery-main]'); if (gm && gm._gstep) gm._gstep(e.key === 'ArrowRight' ? 1 : -1);
    }
  });

  /* ---------- header over hero ---------- */
  var mast = $('#mast');
  function mastState() {
    if (!mast) return;
    var first = $('#MainContent > .shopify-section:first-child');
    var hasHero = !!(first && first.querySelector('.hero, .story-hero, .contact-banner'));
    mast.classList.toggle('overhero', hasHero && window.scrollY <= 24);
  }
  window.addEventListener('scroll', mastState, { passive: true });
  window.addEventListener('resize', mastState);
  document.addEventListener('shopify:section:load', mastState);
  mastState();

  /* ---------- announcement rotation ---------- */
  (function () {
    var bar = $('#announce'); if (!bar) return;
    var msgs = $$('span', bar), mi = 0;
    if (msgs.length < 2) return;
    setInterval(function () {
      msgs[mi].classList.remove('show'); mi = (mi + 1) % msgs.length; msgs[mi].classList.add('show');
    }, parseInt(bar.getAttribute('data-interval'), 10) || 4200);
  })();

  /* ---------- flick cards + blurred fills ---------- */
  function initCards(scope) {
    $$('.card.flick', scope).forEach(function (card) {
      if (card._flick) return; card._flick = true;
      var imgs = $$('.ph img', card), dots = $$('.fdots i', card), fi = 0;
      if (imgs.length < 2) return;
      setInterval(function () {
        imgs[fi].classList.remove('cur'); if (dots[fi]) dots[fi].classList.remove('on');
        fi = (fi + 1) % imgs.length;
        imgs[fi].classList.add('cur'); if (dots[fi]) dots[fi].classList.add('on');
      }, 2600);
    });
    $$('.card .ph', scope).forEach(function (ph) {
      if (ph._fill) return; ph._fill = true;
      var im = ph.querySelector('img'); if (!im) return;
      var d = document.createElement('div'); d.className = 'phfill';
      function setFill() { var src = im.currentSrc || im.src; if (src) d.style.backgroundImage = 'url("' + src + '")'; }
      setFill(); im.addEventListener('load', setFill);
      ph.insertBefore(d, ph.firstChild);
    });
  }
  initCards(document);
  document.addEventListener('shopify:section:load', function (e) { initCards(e.target); });

  /* ---------- reveals ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: .12 });
    $$('.rev').forEach(function (el) { io.observe(el); });
  } else { $$('.rev').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- Billy paw stamps ---------- */
  $$('[data-billy-band]').forEach(function (billy) {
    var stamps = 0;
    billy.addEventListener('click', function (e) {
      if (e.target.closest('a,button,input')) return;
      if (stamps > 44) return;
      var r = billy.getBoundingClientRect();
      var s = document.createElement('span'); s.className = 'bb-stamp';
      s.style.left = (e.clientX - r.left - 17) + 'px'; s.style.top = (e.clientY - r.top - 17) + 'px';
      s.style.transform = 'rotate(' + ((stamps * 47) % 40 - 20) + 'deg)';
      s.innerHTML = '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="16" rx="4.6" ry="4"/><ellipse cx="5.4" cy="10.6" rx="2" ry="2.6"/><ellipse cx="9.4" cy="6.6" rx="2" ry="2.7"/><ellipse cx="14.6" cy="6.6" rx="2" ry="2.7"/><ellipse cx="18.6" cy="10.6" rx="2" ry="2.6"/></svg>';
      billy.appendChild(s); stamps++;
      var hint = billy.querySelector('[data-billy-hint]'); if (hint && stamps === 1) hint.style.opacity = '.55';
    });
  });

  /* ---------- name helpers ---------- */
  function cleanName(v) { return v.replace(/[^A-Za-z \-']/g, '').toUpperCase(); }
  function fitStrip(el, t) { var n = (t || 'BILLY').length; el.style.fontSize = Math.min(52, Math.floor(400 / Math.max(1, n))) + 'px'; }
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) { } },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) { } }
  };
  $$('[data-plate-input]').forEach(function (inp) {
    inp.addEventListener('input', function () { inp.value = cleanName(inp.value); store.set('mb_dog_name', inp.value.trim()); });
  });
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-plate-go]'); if (!go) return;
    var inp = go.closest('.copy, .story-cta'); inp = inp && inp.querySelector('[data-plate-input]');
    if (inp && inp.value.trim()) store.set('mb_dog_name', inp.value.trim());
  });
  $$('[data-name-input]').forEach(function (inp) {
    var strip = inp.getAttribute('data-strip-target'); strip = strip && document.getElementById(strip);
    inp.addEventListener('input', function () {
      inp.value = cleanName(inp.value);
      if (strip) { strip.textContent = inp.value || (strip.getAttribute('data-default') || 'BILLY'); fitStrip(strip, inp.value); }
    });
    if (strip) strip.setAttribute('data-default', strip.textContent);
  });

  /* ---------- newsletter popup ---------- */
  function markPopupSeen() {
    var p = $('#popup'); if (!p) return;
    var days = parseInt(p.getAttribute('data-popup-days'), 10) || 7;
    store.set('mb_popup_until', String(Date.now() + days * 86400000));
  }
  (function () {
    var p = $('#popup'); if (!p) return;
    if (p.querySelector('.form-msg.ok')) { p.classList.add('show'); markPopupSeen(); return; }
    var until = parseInt(store.get('mb_popup_until') || '0', 10);
    if (until > Date.now()) return;
    if (window.Shopify && Shopify.designMode) return;
    setTimeout(function () { if (!$('.popup.show') && !$('#cart.show')) open('popup'); }, (parseInt(p.getAttribute('data-popup-delay'), 10) || 5) * 1000);
  })();

  /* ---------- policies tabs ---------- */
  (function () {
    var nav = $('[data-policy-nav]'); if (!nav) return;
    function show(doc) {
      $$('button', nav).forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-doc') === doc); });
      $$('.pol-doc').forEach(function (d) { d.classList.toggle('on', d.id === 'pol-' + doc); });
    }
    $$('button', nav).forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-doc')); history.replaceState(null, '', '#' + b.getAttribute('data-doc')); }); });
    var h = location.hash.replace('#', '');
    if (h && document.getElementById('pol-' + h)) show(h);
  })();

  /* ---------- cart ---------- */
  var drawer = $('[data-cart-drawer]');
  function req(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refreshCart() {
    return fetch(T.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function renderCart(cart) {
    var count = $('#cartCount'); if (count) { count.textContent = cart.item_count; count.classList.toggle('zero', cart.item_count === 0); }
    if (!drawer) return cart;
    var dc = $('#drawerCount'); if (dc) dc.textContent = cart.item_count;
    var sub = $('#subTotal'); if (sub) sub.textContent = money(cart.total_price);
    var ap = $('#apTotal'); if (ap) ap.textContent = money(Math.round(cart.total_price / 4));
    var FREE = T.freeShipping || 10000, msg = $('#shipMsg'), fill = $('#shipFill');
    if (msg && fill) {
      if (cart.total_price <= 0) { msg.innerHTML = 'Free shipping on orders over <b>' + moneyShort(FREE) + '</b>' + (T.shipRegion ? ' in ' + esc(T.shipRegion) : ''); fill.style.width = '0%'; }
      else if (cart.total_price >= FREE) { msg.innerHTML = '<b>You’ve unlocked free shipping.</b>'; fill.style.width = '100%'; }
      else { msg.innerHTML = 'You’re <b>' + money(FREE - cart.total_price) + '</b> away from free shipping'; fill.style.width = Math.round(cart.total_price / FREE * 100) + '%'; }
    }
    var box = $('#drawerItems'), xs = $('#xsell');
    if (!box) return cart;
    if (!cart.items.length) {
      box.innerHTML = '<div class="empty-cart">Your cart is empty.<br><br><a class="btn" href="' + esc(box.getAttribute('data-empty-link') || '/collections/all') + '" data-close="cart" style="font-size:12px;padding:12px 22px">' + esc(box.getAttribute('data-empty-label') || 'Shop') + '</a></div>';
      if (xs) xs.style.display = 'none';
      return cart;
    }
    if (xs) xs.style.display = '';
    box.innerHTML = cart.items.map(function (l) {
      var props = '';
      Object.keys(l.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && l.properties[k]) props += '<div class="pr">' + esc(k) + ': ' + esc(l.properties[k]) + '</div>'; });
      var disc = '';
      if (l.line_level_total_discount > 0) disc = '<div class="pr save">You save ' + money(l.line_level_total_discount) + '</div>';
      return '<div class="d-item" data-key="' + esc(l.key) + '">' +
        '<div class="im">' + (l.image ? '<img src="' + esc(l.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2')) + '" alt="">' : '') + '</div>' +
        '<div><div class="nm"><a href="' + esc(l.url) + '">' + esc(l.product_title) + '</a></div>' +
        (l.variant_title && l.variant_title !== 'Default Title' ? '<div class="pr">' + esc(l.variant_title) + '</div>' : '') + props + disc +
        '<div class="qty"><button type="button" data-cart-qty="-1" aria-label="Decrease">−</button><span>' + l.quantity + '</span><button type="button" data-cart-qty="1" aria-label="Increase">+</button></div>' +
        '<button type="button" class="rm" data-cart-remove>Remove</button></div>' +
        '<div class="pp">' + money(l.final_line_price) + '</div></div>';
    }).join('');
    return cart;
  }
  function cartAdd(items) {
    return req(T.routes.cartAdd + '.js', { items: items }).then(function () { return refreshCart(); }).then(function (c) { open('cart'); return c; })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart.'); throw err; });
  }
  function cartChange(key, qty) {
    return req(T.routes.cartChange + '.js', { id: key, quantity: qty }).then(renderCart).catch(function (err) { toast((err && err.description) || 'Could not update cart.'); });
  }
  window.mbCart = { add: cartAdd, refresh: refreshCart, change: cartChange };
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      var item = q.closest('.d-item');
      if (item) {
        var span = item.querySelector('.qty span'); var cur = parseInt(span.textContent, 10) || 1;
        cartChange(item.getAttribute('data-key'), Math.max(0, cur + parseInt(q.getAttribute('data-cart-qty'), 10)));
      } else {
        var line = q.getAttribute('data-line'), inp = $('[data-cart-line-qty="' + line + '"]');
        if (inp) { inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(q.getAttribute('data-cart-qty'), 10)); var f = inp.closest('form'); if (f) f.submit(); }
      }
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { var it = rm.closest('.d-item'); if (it) cartChange(it.getAttribute('data-key'), 0); return; }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { qa.disabled = true; cartAdd([{ id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 }]).then(function () { toast(T.strings.added); }).finally(function () { qa.disabled = false; }); }
  });

  /* ---------- generic pickers: data-group / data-v ---------- */
  function setPick(group, v, scope) {
    $$('[data-group="' + group + '"] [data-v]', scope).forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-v') === v); });
    var lbl = $('[data-group-label="' + group + '"]', scope); if (lbl) lbl.textContent = v;
    var inp = $('[data-group-input="' + group + '"]', scope); if (inp) inp.value = v;
  }
  function getPick(group, scope) { var b = $('[data-group="' + group + '"] [data-v].on', scope); return b ? b.getAttribute('data-v') : null; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-group] [data-v]'); if (!b || b.disabled) return;
    var g = b.closest('[data-group]');
    var section = b.closest('[data-product-section]') || document;
    setPick(g.getAttribute('data-group'), b.getAttribute('data-v'), section);
    var row = b.closest('[data-xsell]');
    if (row && row._update) { row._update(); return; }
    if (section._update && /^option-/.test(g.getAttribute('data-group'))) section._update();
  });

  /* ---------- product sections ---------- */
  function initProduct(sec) {
    if (sec._init) return; sec._init = true;
    var jsonEl = sec.parentElement.querySelector('[data-product-json]') || $('[data-product-json]');
    var P; try { P = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-product-form]', sec), select = $('[data-variant-select]', sec);
    var colourIdx = parseInt(sec.getAttribute('data-colour-index'), 10);
    var persoOpt = (sec.getAttribute('data-perso-option') || '').toLowerCase();
    var persoIdx = -1;
    P.options.forEach(function (o, i) { if (o.toLowerCase() === persoOpt) persoIdx = i; });
    var persoOn = sec.getAttribute('data-perso-on'), persoOff = sec.getAttribute('data-perso-off');
    var persoCheck = $('[data-perso-check]', sec), persoBox = $('[data-perso]', sec), persoName = persoBox && persoBox.querySelector('[data-name-input]');
    var addonId = persoBox && parseInt(persoBox.getAttribute('data-addon-id'), 10) || 0, addonPrice = persoBox && parseInt(persoBox.getAttribute('data-addon-price'), 10) || 0;
    function extra() { return (persoCheck && persoCheck.checked && addonId) ? addonPrice : 0; }
    var hideUnavail = sec.hasAttribute('data-hide-unavailable');
    var sticky = document.querySelector('[data-sticky-atc]');
    var main = $('[data-gallery-main]', sec), thumbsBox = $('[data-gallery-thumbs]', sec);

    function selected() {
      var opts = [];
      P.options.forEach(function (o, i) {
        if (i === persoIdx) opts.push(persoCheck && persoCheck.checked ? persoOn : persoOff);
        else opts.push(getPick('option-' + i, sec));
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < P.variants.length; i++) {
        var v = P.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function currentColour() { return colourIdx >= 0 ? getPick('option-' + colourIdx, sec) : null; }

    /* gallery */
    var visible = [], cur = 0;
    function mediaEls() { return main ? $$('.gmedia', main) : []; }
    function thumbEls() { return thumbsBox ? $$('button', thumbsBox) : []; }
    function showIndex(i) {
      var els = mediaEls(), th = thumbEls();
      els.forEach(function (m) { m.classList.remove('cur'); var v = m.querySelector('video'); if (v) { try { v.pause(); } catch (e) { } } });
      th.forEach(function (b) { b.classList.remove('on'); });
      if (els[i]) els[i].classList.add('cur');
      if (th[i]) th[i].classList.add('on');
      cur = visible.indexOf(i);
      var c = $('[data-gallery-count]', main); if (c) c.textContent = (cur + 1) + ' / ' + visible.length;
      var vid = els[i] && els[i].querySelector('video'); if (vid) { try { vid.play(); } catch (e) { } }
    }
    var galInc = (sec.getAttribute('data-gallery-include') || '').toLowerCase(), galExc = (sec.getAttribute('data-gallery-exclude') || '').toLowerCase();
    function altOf(m) { return (m.getAttribute('data-alt') || '').toLowerCase(); }
    function viewOk(m) { var a = altOf(m); if (galInc && a.indexOf(galInc) < 0) return false; if (galExc && a.indexOf(galExc) > -1) return false; return true; }
    function filterGallery(colour, mediaId) {
      if (!main) return;
      var els = mediaEls(), th = thumbEls();
      var lc = (colour && sec.getAttribute('data-gallery-filter') !== 'false') ? colour.toLowerCase() : '';
      var all = els.map(function (m, i) { return i; });
      /* 1. this colour's photos (or every photo when colour filtering is off) */
      var base = lc ? all.filter(function (i) { return altOf(els[i]).indexOf(lc) > -1; }) : all;
      if (!base.length) base = all;
      /* 2. then only the women's / men's shots for this view, falling back to the colour set */
      var matches = (galInc || galExc) ? base.filter(function (i) { return viewOk(els[i]); }) : base;
      visible = matches.length ? matches : base;
      th.forEach(function (b, i) { b.classList.toggle('hidden', visible.indexOf(i) < 0); });
      main.classList.toggle('single', visible.length < 2);
      var target = visible[0];
      if (mediaId) els.forEach(function (m, i) { if (m.getAttribute('data-media-id') === String(mediaId) && visible.indexOf(i) > -1) target = i; });
      if (target != null) showIndex(target);
    }
    if (main) {
      main._gstep = function (d) { if (!visible.length) return; var n = (cur + d + visible.length) % visible.length; showIndex(visible[n]); };
      var prev = $('[data-gallery-prev]', main), next = $('[data-gallery-next]', main);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); main._gstep(-1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); main._gstep(1); });
      var sx = null, sy = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = sy = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) main._gstep(dx < 0 ? 1 : -1);
      }, { passive: true });
      thumbEls().forEach(function (b, i) { b.addEventListener('click', function () { showIndex(i); }); });
    }

    /* sizes availability */
    function updateSizes(opts) {
      P.options.forEach(function (o, i) {
        if (i === colourIdx || i === persoIdx) return;
        var grp = $('[data-group="option-' + i + '"]', sec); if (!grp) return;
        var missing = [], hasSel = false;
        $$('[data-v]', grp).forEach(function (b) {
          var test = opts.slice(); test[i] = b.getAttribute('data-v');
          function matches(v) { return v.options.every(function (ov, k) { return test[k] == null || ov === test[k]; }); }
          var exists = P.variants.some(matches);
          var anyAvail = P.variants.some(function (v) { return v.available && matches(v); });
          var hide = !exists || (hideUnavail && !anyAvail);
          b.classList.toggle('soldout', exists && !anyAvail);
          b.classList.toggle('hidden', hide);
          if (hide) { missing.push(b.getAttribute('data-v')); b.classList.remove('on'); }
          if (b.classList.contains('on') && !hide) hasSel = true;
        });
        if (!hasSel) { var first = $$('[data-v]:not(.hidden)', grp)[0]; if (first) first.classList.add('on'); }
        var note = $('[data-size-note]', sec);
        if (note && /size/i.test(o)) {
          var tpl = note.getAttribute('data-note-template') || '';
          note.textContent = (missing.length && colourIdx >= 0) ? tpl.replace('[colour]', currentColour() || '').replace('[sizes]', missing.join(' & ')) : '';
        }
      });
    }

    var atc = $('[data-atc]', sec), atcText = $('[data-atc-text]', sec), qtyInput = $('[data-qty-input]', sec);
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function update() {
      var opts = selected();
      updateSizes(opts);
      opts = selected();
      var v = findVariant(opts);
      P.options.forEach(function (o, i) { var l = $('[data-option-label="' + i + '"]', sec); if (l && opts[i]) l.textContent = opts[i]; });
      var price = $('[data-price]', sec), comp = $('[data-compare]', sec), af = $('[data-afterpay]', sec);
      if (v) {
        if (select) select.value = v.id;
        var unit = v.price + extra();
        if (price) price.textContent = money(unit);
        if (comp) comp.textContent = v.compare > v.price ? money(v.compare) : '';
        if (af) af.textContent = money(Math.round(unit * qty() / 4));
        if (atc) { atc.disabled = !v.available; if (atcText) atcText.textContent = v.available ? (atc.getAttribute('data-label') || T.strings.addToCart) + ' · ' + money(unit * qty()) : T.strings.soldOut; }
        if (sticky) { var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = money(unit); }
        var ga = $('[data-gift-amt]', sec); if (ga) ga.textContent = money(v.price).replace(/\.00$/, '');
        filterGallery(currentColour(), v.media_id);
      } else {
        if (atc) { atc.disabled = true; if (atcText) atcText.textContent = T.strings.unavailable; }
        filterGallery(currentColour(), null);
      }
      var pa = $('[data-perso-add]', sec); if (pa) pa.classList.toggle('show', !!(persoCheck && persoCheck.checked));
      if (v && history.replaceState && P.variants.length > 1) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) { } }
    }
    sec._update = update;

    if (persoCheck) {
      persoCheck.addEventListener('change', function () {
        persoBox.classList.toggle('active', persoCheck.checked);
        if (persoName) { persoName.disabled = !persoCheck.checked; if (persoCheck.checked) persoName.focus(); }
        update();
      });
      var saved = store.get('mb_dog_name');
      if (saved && persoName) { persoCheck.checked = true; persoBox.classList.add('active'); persoName.disabled = false; persoName.value = cleanName(saved); persoName.dispatchEvent(new Event('input')); store.del('mb_dog_name'); }
    } else {
      var nf = $('.bb [data-name-input]', sec), saved2 = store.get('mb_dog_name');
      if (nf && saved2) { nf.value = cleanName(saved2); nf.dispatchEvent(new Event('input')); store.del('mb_dog_name'); }
    }
    $$('[data-qty]', sec).forEach(function (b) {
      b.addEventListener('click', function () { if (!qtyInput) return; qtyInput.value = Math.max(1, qty() + parseInt(b.getAttribute('data-qty'), 10)); update(); });
    });
    if (qtyInput) qtyInput.addEventListener('change', update);

    function submit() {
      var opts = selected(), v = findVariant(opts);
      if (!v) { toast(T.strings.pickSize); return; }
      if (!v.available) { toast(T.strings.soldOut); return; }
      if (persoCheck && persoCheck.checked && persoName && !persoName.value.trim()) { toast(T.strings.typeName); persoName.focus(); return; }
      var req = $$('[data-name-input][required]', sec).filter(function (i) { return !i.disabled && !i.value.trim(); });
      if (req.length) { toast(req[0].getAttribute('data-required-msg') || 'Please fill in the name.'); req[0].focus(); return; }
      var props = {};
      $$('input[name^="properties["]', form).forEach(function (i) { if (i.disabled) return; var k = i.name.replace(/^properties\[|\]$/g, ''); if (i.type === 'checkbox' && !i.checked) return; if (i.value.trim()) props[k] = i.value.trim(); });
      var items = [{ id: v.id, quantity: qty(), properties: props }];
      if (persoCheck && persoCheck.checked && addonId) items.push({ id: addonId, quantity: qty(), properties: { "Dog's name": persoName.value.trim(), "For": P.title + ' ' + (v.title || '') } });
      if (atc) atc.classList.add('loading');
      cartAdd(items).then(function () { toast(T.strings.added); }).catch(function () { }).finally(function () { if (atc) atc.classList.remove('loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (sticky) {
      var sb = $('[data-sticky-add]', sticky); if (sb) sb.addEventListener('click', submit);
      function stickyCheck() { sticky.classList.toggle('act', window.innerWidth <= 960 && window.scrollY > 520); }
      window.addEventListener('scroll', stickyCheck, { passive: true }); window.addEventListener('resize', stickyCheck); stickyCheck();
    }

    /* cross-sell rows */
    $$('[data-xsell]', sec).forEach(function (row) {
      var X; try { X = JSON.parse(row.querySelector('[data-xsell-json]').textContent); } catch (e) { return; }
      var img = $('[data-xsell-img]', row), price = $('[data-xsell-price]', row), addBtn = $('[data-xsell-add]', row);
      var nameT = $('[data-xsell-name-toggle]', row), nameI = $('[data-xsell-name]', row), nameN = $('[data-xsell-name-note]', row);
      function groups() { return $$('[data-group]', row).map(function (g) { return { idx: parseInt(g.getAttribute('data-option-index'), 10), v: getPick(g.getAttribute('data-group'), row) }; }); }
      function xvariant() {
        var gs = groups(), opts = X.options.map(function (o) { return (o.toLowerCase() === persoOpt) ? (nameT && nameT.checked ? persoOn : persoOff) : null; });
        gs.forEach(function (g) { opts[g.idx] = g.v; });
        for (var i = 0; i < X.variants.length; i++) { var v = X.variants[i], ok = true; for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } } if (ok) return v; }
        return null;
      }
      row._update = function () {
        var v = xvariant();
        var xa = nameT && nameT.checked ? (parseInt(nameT.getAttribute('data-addon-price'), 10) || 0) : 0;
        if (v) { if (price) price.textContent = money(v.price + xa); if (img && v.image) img.src = v.image; if (addBtn) addBtn.disabled = !v.available; }
        else if (addBtn) addBtn.disabled = true;
      };
      if (nameT) nameT.addEventListener('change', function () {
        var on = nameT.checked; if (nameI) { nameI.style.display = on ? '' : 'none'; if (on) nameI.focus(); } if (nameN) nameN.style.display = on ? '' : 'none'; row._update();
      });
      if (nameI) nameI.addEventListener('input', function () { nameI.value = cleanName(nameI.value); });
      if (addBtn) addBtn.addEventListener('click', function () {
        var v = xvariant(); if (!v) { toast(T.strings.pickSize); return; }
        var props = {};
        if (nameT && nameT.checked) { if (!nameI.value.trim()) { toast(T.strings.typeName); nameI.focus(); return; } props[nameI.getAttribute('data-property') || "Dog's name"] = nameI.value.trim(); }
        var xitems = [{ id: v.id, quantity: 1, properties: props }];
        var xaid = nameT && nameT.checked ? parseInt(nameT.getAttribute('data-addon-id'), 10) : 0;
        if (xaid) xitems.push({ id: xaid, quantity: 1, properties: { "Dog's name": nameI.value.trim(), "For": X.title + ' ' + (v.title || '') } });
        addBtn.classList.add('loading');
        cartAdd(xitems).then(function () { toast(T.strings.added); }).catch(function () { }).finally(function () { addBtn.classList.remove('loading'); });
      });
      row._update();
    });

    update();
  }
  $$('[data-product-section]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-product-section]', e.target).forEach(initProduct); });

  /* initial cart count sync */
  if ($('#cartCount')) refreshCart().catch(function () { });
})();
